import React, { useState } from 'react'
import '../styles/headerComponent.css'


const Header = (props) => {

    const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  }

// const changeColor = () => {
// const allElements = document.querySelectorAll('*')
// const allElementsP = document.querySelectorAll('p')
// const allElementsH1 = document.querySelectorAll('h1')
// const allElementsH2 = document.querySelectorAll('h2')
// const allElementsH3 = document.querySelectorAll('h3')
// const allElementsEncima = document.querySelectorAll('.encima')
// const allElementsSvg = document.querySelectorAll('svg')
// const allElementsA = document.querySelectorAll('a')
// const allElementsADownload = document.querySelectorAll('.DownloadCv')
// const allElementsButton = document.querySelectorAll('button')

// allElementsADownload.forEach(elementADownload => {
//   elementADownload.style.backgroundColor = 'green'
// })

// allElementsA.forEach(elementA => {
//   elementA.style.color = 'black'
// })

// allElementsSvg.forEach(elementSvg => {
//   elementSvg.style.color = 'black'
// })

// allElementsEncima.forEach(elementEncima => {
//   elementEncima.style.color = 'black'
// })

// allElementsH1.forEach(elementh1 => {
//   elementh1.style.color = 'black'
// })

// allElementsH2.forEach(elementh2 => {
//   elementh2.style.color = 'black'
// })

// allElementsH3.forEach(elementh3 => {
//   elementh3.style.color = 'black'
// })

// allElementsP.forEach(elementp => {
//   elementp.style.color = 'black'
// })

// allElementsButton.forEach(elementButton => {
//   elementButton.style.backgroundColor = 'green'
// })

// // Iterar sobre todos los elementos seleccionados y aplicar el estilo
// allElements.forEach(element => {
//   if (!element.matches('button')) {
//     element.style.backgroundColor = 'white'
//   }
// })

// }
  return (
    <header>
      <div className="HeaderContainer">
        <div className="HeaderTitle">
          <h1>SantiOcampo</h1>
        </div>
        <div className={`HeaderMenu ${menuOpen ? 'MenuOpen' : ''}`}>
          <div className="MenuIcon" onClick={toggleMenu}>
            <div className="Bar"></div>
            <div className="Bar"></div>
            <div className="Bar"></div>
          </div>
          <div className="HeaderLinks">
            <a href="#Home" className="Home">
              {props.home}
            </a>
            <a href="#About" className="About">
              {props.about}
            </a>
            <a href="#Projects" className="Projects">
              {props.projects}
            </a>
            <a href="#ContactMe" className="ContactMe">
              {props.contact}
            </a>
            <button className="toggleLanguageButton " onClick={props.toggleLanguage}>
              {props.button}
            </button>
            {/* <button onClick={changeColor} className="changeColorButton">
              ddd
            </button> */}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
